export default __webpack_public_path__ + "static/media/slide-3.46efc273.webp";